import React, { useState } from 'react'
import { connect } from "react-redux"
import { styled } from '@mui/material/styles'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { AppBar, Toolbar, IconButton, Button, MenuItem, Menu, Tooltip, Box, Stack } from '@mui/material'

import {
  AccountCircle,
  ArrowDropDown as ArrowDropDownIcon,
  MenuRounded as MenuRoundedIcon,
  DocumentScanner as DocumentScannerIcon,
} from '@mui/icons-material'

import MenuVertical from '../Menu/Menu'
import { logout } from '../../../state/actions'
import Logo from '../../../common/components/Svgs/Logo'
import './Header.sass'

function Header(props) {

  const {
    logoSrc,
    firstName,
    logout,
    enabledInfraRedReader,
    scannerStatus,
  } = props

  const [anchorEl, setAnchorEl] = React.useState(null)
  const navigate = useNavigate()
  const { t } = useTranslation()
  const handleMenu = event => setAnchorEl(event.currentTarget)
  const handleClose = () => setAnchorEl(null)
  const [open, setOpen] = useState(false);

  const handleOption = option => {
    if (option === 'logout') logout(navigate)
    else if (option === 'information') navigate('/information')
    else if (option === 'settings') navigate('/settings')
  }

  const StyledMenu = styled(props => (
    <Menu
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      {...props}
    />
  ))(() => ({
    '& .MuiList-root ': {
      padding: '0px'
    },
    '& .MuiPaper-root': {
      borderRadius: '0 0 4px 4px',
      minWidth: 229,
      color: 'black',
      background: '#F9F9F9',
      boxShadow: '0px 0px 6px rgba(146, 146, 146, 0.5)'
    },
    '& .MuiMenuItem-root:hover': {
      background: '#D8DFF5'
    }
  }));

  return (
    <AppBar position="static" className="header">
      <Toolbar className="header-toolbar">
        <IconButton
          size="large"
          edge="start"
          color="white"
          aria-label="menu"
          onClick={() => setOpen(!open)}
        >
          <MenuRoundedIcon />
        </IconButton>


        <Button variant="text" onClick={() => navigate('/')}>
          <div className='logo-img-wrapper'>
            {logoSrc ?
              <img
                src={logoSrc}
                alt={t("logo")}
                className='logo-img'
              />
              :
              <Logo className='logo-img' />
            }
          </div>
        </Button>
        <p>{t("| Lobby")}</p>
        <Stack direction="row" alignItems="center" className='ml-auto'>
          {window.electronAPI && enabledInfraRedReader && (
            <Tooltip
              title={
                scannerStatus === 'connected'
                  ? t('Infrared reader connected')
                  : scannerStatus === 'reconnecting'
                    ? t('Reconnecting infrared reader...')
                    : t('Infrared reader disconnected')
              }
              arrow
            >
              <Box sx={{ display: 'inline-flex', alignItems: 'center', mr: 1, position: 'relative' }}>
                <DocumentScannerIcon sx={{ color: '#FFF', fontSize: 22 }} />
                <Box
                  sx={{
                    width: 8,
                    height: 8,
                    borderRadius: '50%',
                    backgroundColor: scannerStatus === 'connected' ? '#4CAF50' : '#9E9E9E',
                    position: 'absolute',
                    bottom: 2,
                    right: -2,
                    border: '1.5px solid #50629C',
                    animation: scannerStatus === 'reconnecting' ? 'pulse 1.5s infinite' : 'none',
                    '@keyframes pulse': {
                      '0%': { opacity: 1 },
                      '50%': { opacity: 0.3 },
                      '100%': { opacity: 1 },
                    },
                  }}
                />
              </Box>
            </Tooltip>
          )}
          <IconButton
            size="large"
            aria-label="account of current user"
            aria-controls="menu-app-bar"
            aria-haspopup="true"
            className="header-options"
            onClick={handleMenu}
            color="inherit"
          >
            <AccountCircle />
            <p className="username">
              {firstName}
            </p>
            <ArrowDropDownIcon />
          </IconButton>
          <StyledMenu
            id="menu-app-bar"
            keepMounted
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleClose}
          >
            <MenuItem onClick={() => handleOption('settings')}>{t('settings')}</MenuItem>
            <MenuItem onClick={() => handleOption('logout')}>{t('logout')}</MenuItem>
          </StyledMenu>
        </Stack>
      </Toolbar>
      <MenuVertical open={open} setOpen={setOpen} />
    </AppBar>
  )
}

const mapStateToProps = state => {
  return {
    firstName: state.profile.first_name,
    logoSrc: state.profile.logo,
    enabledInfraRedReader: state.setting.enabledInfraRedReader,
    scannerStatus: state.setting.scannerStatus,
  }
}

const mapDispatchToProps = {
  logout
}


export default connect(mapStateToProps, mapDispatchToProps)(Header)